/**
 * 商户列表
 */
<template>
  <div class="merchant-list-page">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" class="page-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商户列表</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="search-section">
      <el-form :inline="true" :model="formInline" size="small" class="search-form">
        <el-form-item label="商户类型">
          <el-select
            v-model="formInline.agentType"
            placeholder="全部"
            clearable
          >
            <el-option
              v-for="(val, index) in merchantTypeList"
              :label="val.label"
              :value="val.value"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商户名称">
          <el-select
            v-model="formInline.merchantName"
            filterable
            allow-create
            default-first-option
            placeholder="请选择或输入商户名称"
            @blur="selectMerchantNameBlur"
            class="search-input"
          >
            <el-option
              v-for="(val, index) in merchantList"
              :label="val"
              :value="val"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务商">
          <el-select
            v-model="formInline.disCompanyName"
            filterable
            allow-create
            default-first-option
            placeholder="请选择或输入服务商名称"
            @blur="selectDisCompanyBlur"
            class="search-input"
          >
            <el-option
              v-for="(val, index) in disCompanyList"
              :label="val.label"
              :value="val.label"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="返点">
          <el-select
            v-model="formInline.hasRebate"
            placeholder="全部"
            clearable
          >
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="formInline.date"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button icon="el-icon-refresh-left" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="toolbar">
      <el-button type="primary" size="small" icon="el-icon-download" @click="exportdata">导出数据</el-button>
      <el-button type="primary" size="small" icon="el-icon-search" @click="onSearchMerchants">检索商户</el-button>
    </div>

    <el-card shadow="hover" class="table-card">
      <el-table
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        element-loading-text="加载中..."
        empty-text="暂无数据"
        style="width: 100%"
      >
      <!-- <el-table-column align="center" type="selection" width="60">
      </el-table-column> -->
      <el-table-column
        fixed
        prop="merchantName"
        label="商户名称"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column prop="agentType" label="类型" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ getAgentTypeLabel(scope.row.merchantType) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="phoneSalesName" label="电销" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="faceSalesName" label="面销" show-overflow-tooltip>
      </el-table-column>
      <!-- T-005: REQ-002 F003 追加转交两列(原有列保留, 未转交显示"--") -->
      <el-table-column prop="transferPhoneSalesName" label="转交电销" min-width="110" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.transferPhoneSalesName || '--' }}
        </template>
      </el-table-column>
      <el-table-column prop="transferFaceSalesName" label="转交面销" min-width="110" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.transferFaceSalesName || '--' }}
        </template>
      </el-table-column>
      <el-table-column prop="industry" label="所属行业" show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="managementFeeRate"
        label="管理费率"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ formatRate(scope.row.managementFeeRate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="actualQuotePrice"
        label="实际报价"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ formatRate(scope.row.actualQuotePrice) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="rebate" label="返点" show-overflow-tooltip>
        <template slot-scope="scope">
          <span
            :style="{
              color:
                scope.row.rebate != null &&
                scope.row.rebate !== '' &&
                Number(scope.row.rebate) !== 0
                  ? '#f56c6c'
                  : '#909399',
            }"
          >
            {{ formatRate(scope.row.rebate) || '0.00%' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="distributeCompanyName"
        label="下发公司"
        show-overflow-tooltip
      >
      </el-table-column>
    </el-table>

      <div class="pagination-wrap">
        <Pagination
          v-bind:child-msg="pageparm"
          @callFather="callFather"
        ></Pagination>
      </div>
    </el-card>

    <el-dialog title="检索商户" :visible.sync="dialogTableVisible">
      <el-table :data="dialogTableData" size="small">
        <el-table-column
          property="companyName"
          label="商户名称"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          property="status"
          label="签约状态"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span
              :style="{
                color: scope.row.status === '已签约' ? '#67C23A' : '#F56C6C',
              }"
            >
              {{ scope.row.status }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSalesMerchants,
  getSalesMerchantName,
  getDisCompanyNames,
  searchMerchants,
} from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      infos: {
        totalServiceFee: 0,
        totalCommission: 0,
      },
      activities: [],
      merchantList: [],
      disCompanyList: [],
      merchantTypeList: [
        {
          label: "普通商户",
          value: 1,
        },
        {
          label: "代理商户",
          value: 2,
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载

      dialogTableData: [],
      dialogTableVisible: false,

      // rules表单验证
      rules: {},
      formInline: {
        page: 1,
        pageSize: 10,
        merchantName: "",
        disCompanyName: "",
        startDate: "",
        endDate: "",
        agentType: "",
        hasRebate: "",
        date: [],
      },

      listData: [], //用户数据
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */
  computed: {},
  /**
   * 创建完毕
   */
  created() {
    getSalesMerchantName({
      page: 1,
      pageSize: 9999,
    })
      .then((res) => {
        if (res.msg == "success") {
          this.merchantList = res.data.items;
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      })
      .catch((err) => {});
    // 服务商
    getDisCompanyNames({
      page: 1,
      pageSize: 9999,
      type: 2,
    })
      .then((res) => {
        if (res.msg == "success") {
          this.disCompanyList = res.data;
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      })
      .catch((err) => {});
    this.getdata(this.formInline);
  },

  watch: {
    "formInline.agentType": function (newVal) {
      let params = {
        agentType: newVal,
      };

      getSalesMerchantName(params)
        .then((res) => {
          if (res.msg == "success") {
            this.merchantList = res.data.items;
            this.formInline.merchantName = "";
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {});
    },
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    statusCellStyle({ row }) {
      console.log(row.status);
      return row.status === "已签约"
        ? "color: #67C23A;" // 绿色
        : "color: #F56C6C;"; // 红色
    },
    onSearchMerchants() {
      this.$prompt("请输入检索商户", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^[\s\S]{1,100}$/,
        inputErrorMessage: "请输入有效的商户名称",
      })
        .then(({ value }) => {
          const trimmedValue = value.trim();

          searchMerchants({
            merchantName: trimmedValue,
          }).then((res) => {
            if (res.msg == "success") {
              this.dialogTableVisible = true;
              if (res.data && res.data.length > 0) {
                // 后端有数据，渲染数据并设置状态为"已签约"
                this.dialogTableData = res.data.map((item) => ({
                  companyName: item.companyName,
                  status: "已签约", // 统一设置状态为已签约
                }));
              } else {
                // 数组为空
                this.dialogTableData = [
                  {
                    companyName: trimmedValue,
                    status: "未签约",
                  },
                ];
              }
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    reset() {
      this.formInline = {
        page: 1,
        pageSize: 10,
        merchantName: "",
        disCompanyName: "",
        agentType: "",
        hasRebate: "",
        date: [],
      };
      this.getdata(this.formInline);
    },
    // 获取公司列表
    getdata(formInline) {
      let params = {
        page: formInline.page,
        pageSize: formInline.pageSize,
        disCompanyName: formInline.disCompanyName,
        merchantName: formInline.merchantName,
        startDate: formInline.startDate,
        endDate: formInline.endDate,
        agentType: formInline.agentType,
        hasRebate: formInline.hasRebate === "" ? undefined : formInline.hasRebate,
      };
      getSalesMerchants(params)
        .then((res) => {
          if (res.msg == "success") {
            this.listData = res.data.items;
            this.pageparm.page = res.data.page;
            this.pageparm.pageSize = res.data.pageSize;
            this.pageparm.total = res.data.totalCount;
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {});
    },
    exportdata() {
      // 默认导出99999
      let params = {
        page: 1,
        pageSize: 99999,
        merchantName: this.formInline.merchantName,
        disCompanyName: this.formInline.disCompanyName,
        startDate: this.formInline.startDate,
        endDate: this.formInline.endDate,
        agentType: this.formInline.agentType,
        hasRebate:
          this.formInline.hasRebate === "" ? undefined : this.formInline.hasRebate,
        export: 1,
      };
      getSalesMerchants(params)
        .then((res) => {
          if (res.msg == "success") {
            if (res.data && res.data.downloadUrl) {
              window.open(res.data.downloadUrl);
            } else {
              this.$message({
                type: "error",
                message: "导出链接为空，请联系管理员",
              });
            }
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {});
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      if (this.formInline.date && this.formInline.date.length === 2) {
        this.formInline.startDate = this.formInline.date[0] || "";
        this.formInline.endDate = this.formInline.date[1] || "";
      } else {
        this.formInline.startDate = "";
        this.formInline.endDate = "";
      }
      this.getdata(this.formInline);
    },
    getAgentTypeLabel(agentType) {
      const type = this.merchantTypeList.find(
        (item) => item.value === agentType
      );
      return type ? type.label : "未知";
    },

    formatRate(rate) {
      if (rate != null && rate !== undefined) {
        return `${(parseFloat(rate) * 100).toFixed(2)}%`;
      }
      return ""; // 或者根据你的需求返回其他默认值
    },
    selectBlur(e) {
      this.formInline.merchantName = e.target.value;
    },
    formatNumber(num) {
      return num ? num.toFixed(2) : "0.00";
    },
    selectMerchantNameBlur(e) {
      this.formInline.merchantName = e.target.value;
    },
    selectDisCompanyBlur(e) {
      this.formInline.disCompanyName = e.target.value;
    },
  },
};
</script>

<style scoped>
.merchant-list-page {
  padding-bottom: 24px;
}
.page-breadcrumb {
  margin-bottom: 0;
}
.search-section {
  margin-top: 24px;
  margin-bottom: 16px;
  padding: 16px 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}
.search-form .el-form-item {
  margin-bottom: 10px;
  margin-right: 20px;
}
.search-form .search-input {
  width: 220px;
}
.toolbar {
  margin: 16px 0;
}
.table-card {
  border-radius: 8px;
  overflow: hidden;
}
.table-card >>> .el-card__body {
  padding: 20px;
}
.pagination-wrap {
  margin-top: 16px;
}
</style>

 


// WEBPACK FOOTER //
// src/views/sales/merchantList.vue